export default "__VITE_ASSET__0f616bc0__"